import { writable } from 'svelte/store';

function persistedWritable<T>(key: string, initial: T) {
  if (typeof window !== 'undefined') {
    const stored = localStorage.getItem(key);
    if (stored !== null) {
      try {
        initial = JSON.parse(stored) as T;
      } catch {}
    }
  }
  const store = writable<T>(initial);
  if (typeof window !== 'undefined') {
    store.subscribe(value => {
      localStorage.setItem(key, JSON.stringify(value));
    });
  }
  return store;
}

export const sidebarOpen = writable(false);
export const sidebarCollapsed = persistedWritable('sidebar-collapsed', false);
export const currentPage = writable('dashboard');

export function toggleSidebar() {
  sidebarOpen.update(v => !v);
}

export function toggleSidebarCollapsed() {
  sidebarCollapsed.update(v => !v);
}
